var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Button from '@web/components/layout/Button';
import Modal, { ModalSize } from '@web/components/layout/Modal';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { useTranslation } from 'react-i18next';
var DeleteDocumentAlertConfigModal = function (_a) {
    var visible = _a.visible, documentAlertConfigId = _a.documentAlertConfigId, onClose = _a.onClose, onDeleted = _a.onDeleted;
    var t = useTranslation().t;
    var toast = useToast().toast;
    var deleteDocumentAlertConfig = trpc.deleteDocumentAlertConfig.useMutation();
    var onDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!documentAlertConfigId)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteDocumentAlertConfig.mutateAsync({
                            documentAlertConfigId: documentAlertConfigId
                        })];
                case 2:
                    _b.sent();
                    toast({
                        title: t('docAlerts.docAlertsConfig.successfullyDeleted'),
                        variant: 'success',
                        duration: 3000
                    });
                    onDeleted();
                    onClose();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    toast({
                        title: t('docAlerts.docAlertsConfig.deleteError'),
                        variant: 'error',
                        duration: 3000
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Modal, __assign({ visible: visible, onClose: onClose, size: ModalSize.LG }, { children: [_jsx("div", __assign({ className: "p-8" }, { children: _jsxs("div", __assign({ className: "flex" }, { children: [_jsx("div", { children: _jsx("div", __assign({ className: "rounded-full p-2 bg-red-100 mr-4" }, { children: _jsx(ExclamationTriangleIcon, { className: "text-red-600 h-6 w-6", "aria-hidden": "true" }) })) }), _jsxs("div", __assign({ className: "max-w-lg" }, { children: [_jsx("h3", __assign({ className: "text-xl font-semibold" }, { children: t('docAlerts.docAlertsConfig.deleteConfirmationTitle') })), _jsx("p", __assign({ className: "text-gray-500" }, { children: t('docAlerts.docAlertsConfig.deleteConfirmationDescription') }))] }))] })) })), _jsx("div", __assign({ className: "mt-5 sm:mt-6" }, { children: _jsx("div", __assign({ className: "flex justify-end" }, { children: _jsxs("div", __assign({ className: "flex" }, { children: [_jsx(Button, __assign({ variant: "white", className: "mr-5", onClick: onClose }, { children: t('button.cancel') })), _jsx(Button, __assign({ variant: "danger", onClick: onDelete, disabled: deleteDocumentAlertConfig.isLoading }, { children: t('button.delete') }))] })) })) }))] })));
};
export default DeleteDocumentAlertConfigModal;
